import { useGameStore } from '../stores/gameStore.js';

/**
 * Notifications "frappe à la porte" — domaine séparé de la proximité/bulles
 * proprement dite (voir useProximity.ts) : jamais co-lu avec localBubbleId/
 * proximityCount/playerBubbleIds/proximityUserIds sur aucun site de l'audit.
 * knockRequests et son action sont en revanche toujours utilisés ensemble
 * (lecture + suppression dans le même composant), donc un seul hook combiné.
 */
export function useKnockRequests(): {
  knockRequests: Array<{ bubbleId: string; userId: string; displayName: string }>;
  removeKnockRequest: (userId: string) => void;
} {
  const knockRequests = useGameStore((s) => s.knockRequests);
  const removeKnockRequest = useGameStore((s) => s.removeKnockRequest);
  return { knockRequests, removeKnockRequest };
}
